/**
 * QMR LUXE HOMEPAGE JAVASCRIPT
 * Vanilla JS to power all interactivity for the Shopify sections
 * Replaces: React state, Framer Motion, Tailwind JS plugins
 */

(function () {
  'use strict';

  // ============================================================
  // CART STATE (mirrors Shopify cart.json)
  // ============================================================
  let cartState = {
    items: [],
    total_price: 0,
    item_count: 0
  };

  // ============================================================
  // HERO SECTION
  // Now handled internally via JSON and embedded script in qmr-hero.liquid
  // ============================================================

  // ============================================================
  // PRODUCT FILTER SYSTEM
  // ============================================================
  function initProductFilter() {
    const filterBtns = document.querySelectorAll('.qmr-filter-btn');
    const productCards = document.querySelectorAll('.qmr-product-card');
    if (!filterBtns.length) return;

    filterBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const filter = this.dataset.filter;

        // Toggle active button
        filterBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        // Show/hide cards based on collection handle
        productCards.forEach(card => {
          const cardCollection = card.dataset.collectionHandle;
          
          if (cardCollection === filter) {
            card.classList.remove('hidden');
            // Small reflow hack to trigger CSS animation when tab switched
            void card.offsetWidth;
          } else {
            card.classList.add('hidden');
          }
        });
      });
    });
  }

  // ============================================================
  // 3D PRODUCT CARD TILT
  // ============================================================
  function initProductCard3D() {
    const cards = document.querySelectorAll('.qmr-product-card__inner');
    cards.forEach(card => {
      card.addEventListener('mousemove', function (e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const xPct = (x / rect.width) * 100;
        const yPct = (y / rect.height) * 100;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rX = -((y - centerY) / centerY) * 12;
        const rY = ((x - centerX) / centerX) * 12;

        this.style.transform = `perspective(1000px) rotateX(${rX}deg) rotateY(${rY}deg) scale(1.02)`;

        const glow = this.querySelector('.qmr-product-card__glow');
        if (glow) {
          glow.style.background = `radial-gradient(circle 120px at ${xPct}% ${yPct}%, rgba(255,255,255,0.08), transparent)`;
        }
      });

      card.addEventListener('mouseleave', function () {
        this.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)';
      });
    });
  }

  // ============================================================
  // QUICK VIEW MODAL
  // ============================================================
  function initQuickView() {
    const modal = document.getElementById('qmr-quickview-modal');
    if (!modal) return;

    const backdrop = modal.querySelector('.qmr-modal__backdrop');
    const closeBtn = modal.querySelector('.qmr-modal__close');

    // Open Quick View
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-qmr-quickview]');
      if (trigger) {
        e.preventDefault();
        const productData = JSON.parse(trigger.dataset.qmrQuickview || '{}');
        openQuickView(productData);
      }
    });

    // Close
    if (backdrop) backdrop.addEventListener('click', closeQuickView);
    if (closeBtn) closeBtn.addEventListener('click', closeQuickView);

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickView();
    });

    // Size selection inside modal
    modal.addEventListener('click', function (e) {
      const sizeBtn = e.target.closest('.qmr-size-btn');
      if (sizeBtn) {
        modal.querySelectorAll('.qmr-size-btn').forEach(b => b.classList.remove('active'));
        sizeBtn.classList.add('active');
      }
    });

    // Add to cart from modal
    const modalCTA = modal.querySelector('.qmr-modal__cta');
    if (modalCTA) {
      modalCTA.addEventListener('click', function () {
        const variantId = modal.dataset.variantId;
        const activeSize = modal.querySelector('.qmr-size-btn.active');
        if (variantId) {
          addToShopifyCart(variantId, 1);
        }
        closeQuickView();
      });
    }
  }

  function openQuickView(productData) {
    const modal = document.getElementById('qmr-quickview-modal');
    if (!modal) return;

    // Populate modal
    const imgEl = modal.querySelector('.qmr-modal__img');
    const nameEl = modal.querySelector('.qmr-modal__name');
    const catEl = modal.querySelector('.qmr-modal__cat');
    const tagEl = modal.querySelector('.qmr-modal__tag');
    const priceEl = modal.querySelector('.qmr-modal__price');
    const comparePriceEl = modal.querySelector('.qmr-modal__compare-price');

    if (imgEl) imgEl.src = productData.featured_image || '';
    if (imgEl) imgEl.alt = productData.title || '';
    if (nameEl) nameEl.textContent = productData.title || '';
    if (catEl) catEl.textContent = productData.type || '';
    if (tagEl) tagEl.textContent = productData.tag || 'PREMIUM';
    if (priceEl) priceEl.textContent = formatMoney(productData.price);
    if (comparePriceEl) {
      if (productData.compare_at_price && productData.compare_at_price > productData.price) {
        comparePriceEl.textContent = formatMoney(productData.compare_at_price);
        comparePriceEl.style.display = 'block';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // Store variant ID for add to cart
    modal.dataset.variantId = productData.first_available_variant_id || '';

    // Reset sizes
    modal.querySelectorAll('.qmr-size-btn').forEach((btn, i) => {
      if (i === 0) btn.classList.add('active');
      else btn.classList.remove('active');
    });

    // Populate sizes from variants
    const sizesWrap = modal.querySelector('.qmr-modal__sizes');
    if (sizesWrap && productData.variants) {
      sizesWrap.innerHTML = '';
      productData.variants.forEach((variant, i) => {
        const btn = document.createElement('button');
        btn.className = 'qmr-size-btn' + (i === 0 ? ' active' : '');
        btn.textContent = variant.option1 || variant.title;
        btn.dataset.variantId = variant.id;
        btn.addEventListener('click', function () {
          modal.dataset.variantId = this.dataset.variantId;
        });
        if (!variant.available) btn.disabled = true;
        sizesWrap.appendChild(btn);
      });
    }

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuickView() {
    const modal = document.getElementById('qmr-quickview-modal');
    if (!modal) return;
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ============================================================
  // SHOPIFY CART (AJAX API)
  // ============================================================
  function addToShopifyCart(variantId, quantity, successCallback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(res => res.json())
    .then(data => {
      if (data.status === 422) {
        showToast('Item not available');
        return;
      }
      showToast('✓ Added to Bag');
      refreshCart();
      if (successCallback) successCallback(data);
    })
    .catch(err => {
      console.error('QMR Cart Error:', err);
      showToast('Error adding item');
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        cartState = data;
        updateCartUI();
      });
  }
  window.refreshCart = refreshCart; // EXPOSED FOR GLOBAL INTERCEPTOR

  function updateCartUI() {
    // Update cart count badges across the page
    document.querySelectorAll('[data-qmr-cart-count]').forEach(el => {
      el.textContent = cartState.item_count;
    });

    // Update the QMR cart drawer
    renderCartDrawer();
  }

  function renderCartDrawer() {
    const drawer = document.getElementById('qmr-cart-drawer');
    if (!drawer) return;

    const countEl = drawer.querySelector('.qmr-cart-drawer__count');
    if (countEl) countEl.textContent = cartState.item_count + ' ITEMS';

    const itemsWrap = drawer.querySelector('.qmr-cart-drawer__items');
    if (!itemsWrap) return;

    if (cartState.item_count === 0) {
      itemsWrap.innerHTML = `
        <div class="qmr-cart-drawer__empty">
          <div class="qmr-cart-drawer__empty-icon">🛍</div>
          <p class="qmr-cart-drawer__empty-text">
            Your luxury bag is empty. Explore the collection and add hand-crafted items to your cart.
          </p>
        </div>
      `;
      // Hide footer
      const footer = drawer.querySelector('.qmr-cart-drawer__footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    // Show footer
    const footer = drawer.querySelector('.qmr-cart-drawer__footer');
    if (footer) footer.style.display = 'block';

    // Render items
    itemsWrap.innerHTML = cartState.items.map((item, index) => `
      <div class="qmr-cart-item" data-index="${index}" data-key="${item.key}">
        <div class="qmr-cart-item__img-wrap">
          <img class="qmr-cart-item__img" src="${item.image}" alt="${item.product_title}" loading="lazy">
        </div>
        <div class="qmr-cart-item__details">
          <div>
            <div class="qmr-cart-item__name">${item.product_title}</div>
            <div class="qmr-cart-item__variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          </div>
          <div class="qmr-cart-item__bottom">
            <div class="qmr-qty-control">
              <button class="qmr-qty-btn" data-action="decrease" data-key="${item.key}">−</button>
              <span class="qmr-qty-value">${item.quantity}</span>
              <button class="qmr-qty-btn" data-action="increase" data-key="${item.key}">+</button>
            </div>
            <span class="qmr-cart-item__price">${formatMoney(item.line_price)}</span>
          </div>
        </div>
        <button class="qmr-cart-item__remove" data-key="${item.key}" title="Remove">✕</button>
      </div>
    `).join('');

    // Update subtotal
    const subtotalEl = drawer.querySelector('.qmr-cart-drawer__subtotal-amount');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cartState.total_price);
  }

  function initCartDrawer() {
    const drawer = document.getElementById('qmr-cart-drawer');
    if (!drawer) return;

    const backdrop = drawer.querySelector('.qmr-cart-drawer__backdrop');
    const closeBtn = drawer.querySelector('.qmr-cart-drawer__close-btn');

    // Close on backdrop click
    if (backdrop) backdrop.addEventListener('click', closeCartDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

    // Handle qty changes & remove
    drawer.addEventListener('click', function (e) {
      const qtyBtn = e.target.closest('.qmr-qty-btn');
      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const action = qtyBtn.dataset.action;
        const item = cartState.items.find(i => i.key === key);
        if (!item) return;
        const newQty = action === 'increase' ? item.quantity + 1 : Math.max(1, item.quantity - 1);
        updateCartItem(key, newQty);
        return;
      }

      const removeBtn = e.target.closest('.qmr-cart-item__remove');
      if (removeBtn) {
        const key = removeBtn.dataset.key;
        updateCartItem(key, 0);
        return;
      }
    });

    // Open cart drawer when any header cart button clicked
    document.addEventListener('click', function (e) {
      const cartTrigger = e.target.closest('[data-qmr-open-cart]');
      if (cartTrigger) {
        e.preventDefault();
        openCartDrawer();
      }
    });

    // Load initial cart
    refreshCart();
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(res => res.json())
    .then(data => {
      cartState = data;
      updateCartUI();
    });
  }

  function openCartDrawer() {
    const drawer = document.getElementById('qmr-cart-drawer');
    if (!drawer) return;
    refreshCart();
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('qmr-cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ============================================================
  // ADD TO CART FROM PRODUCT CARDS
  // ============================================================
  function initAddToCartButtons() {
    document.addEventListener('click', function (e) {
      // "Add to Cart" direct button on card
      const addBtn = e.target.closest('[data-qmr-add-to-cart]');
      if (addBtn) {
        e.preventDefault();
        const variantId = addBtn.dataset.qmrAddToCart;
        if (variantId) {
          addToShopifyCart(variantId, 1, () => openCartDrawer());
        }
        return;
      }

      // Hero card "ADD TO BAG" button
      const heroAddBtn = e.target.closest('[data-qmr-hero-add-to-cart]');
      if (heroAddBtn) {
        e.preventDefault();
        const variantId = heroAddBtn.dataset.qmrHeroAddToCart;
        if (variantId) {
          addToShopifyCart(variantId, 1, () => openCartDrawer());
        }
      }
    });
  }

  // ============================================================
  // SCROLLING TICKER SETUP
  // ============================================================
  function initTicker() {
    const ticker = document.getElementById('qmr-ticker');
    if (!ticker) return;

    const track = ticker.querySelector('.qmr-ticker__track');
    if (!track) return;

    const speed = parseInt(ticker.dataset.speed || '25');
    track.style.animationDuration = speed + 's';
  }

  // ============================================================
  // INTERSECTION OBSERVER (Scroll Animations)
  // ============================================================
  function initScrollAnimations() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.qmr-animate-on-scroll, .qmr-review-card').forEach(el => {
      observer.observe(el);
    });
  }

  // ============================================================
  // TOAST NOTIFICATION
  // ============================================================
  function showToast(message) {
    let toast = document.getElementById('qmr-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'qmr-toast';
      toast.className = 'qmr-toast';
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('show');

    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => {
      toast.classList.remove('show');
    }, 2800);
  }

  // ============================================================
  // UTILITY: FORMAT MONEY (Shopify style)
  // ============================================================
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (parseInt(cents, 10) / 100).toLocaleString('en-EG', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return 'LE ' + value;
  }

  // ============================================================
  // REVIEWS SECTION DELAY STAGGER
  // ============================================================
  function initReviewStagger() {
    const cards = document.querySelectorAll('.qmr-review-card');
    cards.forEach((card, i) => {
      card.style.transitionDelay = (i * 0.15) + 's';
    });
  }

  // ============================================================
  // INIT ALL
  // ============================================================
  function init() {
    // initHero();
    initProductFilter();
    initProductCard3D();
    initQuickView();
    initCartDrawer();
    initAddToCartButtons();
    initTicker();
    initScrollAnimations();
    initReviewStagger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose public API
  window.QMRHomepage = {
    openCart: openCartDrawer,
    closeCart: closeCartDrawer,
    addToCart: addToShopifyCart,
    showToast: showToast,
    refreshCart: refreshCart
  };

})();
